import { render, staticRenderFns } from "./StockInventoryTool.vue?vue&type=template&id=38a7a60c&"
import script from "./StockInventoryTool.vue?vue&type=script&lang=js&"
export * from "./StockInventoryTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QInput,QField,QSelect,QBanner,QIcon,QSeparator,QCheckbox,QTooltip,QInnerLoading,QSpinnerGears,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QInput,QField,QSelect,QBanner,QIcon,QSeparator,QCheckbox,QTooltip,QInnerLoading,QSpinnerGears,QCardActions,QBtn}, component.options.components || {})
